module.exports = __webpack_public_path__ + "static/media/cross-grey.9a3b8b83.svg";